/**
 * `/reports/new` — author a new report by chatting with Flint.
 *
 * Phase 1a: the chat surface only (no preview pane, no backend). See
 * `apps/web/src/features/reports-ai/` for the component. TODO(1b): once
 * the real backend lands the `Save` handler in that component writes
 * to the database and redirects here to `/reports/$reportKey`.
 *
 * Uses `disableViewportScroll` so the transcript scrolls independently
 * of the composer — same pattern the Ask Flint route uses.
 */
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { WorkspaceShell } from "../../../features/workspace/index.ts";
import { ReportAuthoringChat } from "../../../features/reports-ai/index.ts";

/**
 * `?edit=<report-key>` — when present, the chat bootstraps into
 * edit-mode for that saved AI report. Absent = fresh chat as before.
 */
const searchSchema = z.object({
  edit: z.string().optional(),
});

export const Route = createFileRoute("/(workspace)/reports/new")({
  component: NewReportRoute,
  validateSearch: searchSchema,
});

function NewReportRoute() {
  const { edit } = Route.useSearch();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Reports", to: "/reports" },
        { label: edit ? "Edit report" : "New report" },
      ]}
      disableViewportScroll
      hideSectionTabs
      contentClassName="mx-0 flex h-full w-full max-w-none"
    >
      <ReportAuthoringChat {...(edit ? { editReportKey: edit } : {})} />
    </WorkspaceShell>
  );
}
